<template>
  <date-range-picker
    ref="picker"
    :opens="opens"
    :minDate="minDate"
    :maxDate="maxDate"
    :singleDatePicker="singleDatePicker"
    :timePicker24Hour="timePicker24Hour"
    :showWeekNumbers="showWeekNumbers"
    :showDropdowns="showDropdowns"
    :autoApply="autoApply"
    :linkedCalendars="linkedCalendars"
    :ranges="ranges"
    v-model="internalDateRange"
    @update="updateValues"
  >
    <template v-slot:input="picker">
      <div class="compact-date-display">
        {{ formatDate(picker.startDate) }} - {{ formatDate(picker.endDate) }}
      </div>
    </template>
  </date-range-picker>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from "moment";

export default {
  name: "MyDateRangePicker",
  components: { DateRangePicker },
  props: {
    value: Object, // Use v-model in parent to bind
    minDate: String,
    maxDate: String,
  },
  data() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastMonthStart = new Date(
      today.getFullYear(),
      today.getMonth() - 1,
      1
    );
    const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);

    const thisQuarterStart = new Date(
      today.getFullYear(),
      Math.floor(today.getMonth() / 3) * 3,
      1
    );
    const lastQuarterMonth = Math.floor(today.getMonth() / 3) * 3 - 3;
    const lastQuarterStart = new Date(today.getFullYear(), lastQuarterMonth, 1);
    const lastQuarterEnd = new Date(
      today.getFullYear(),
      lastQuarterMonth + 3,
      0
    );

    const thisYearStart = new Date(today.getFullYear(), 0, 1);

    const last7DaysStart = new Date(today);
    last7DaysStart.setDate(today.getDate() - 6);

    return {
      internalDateRange: this.value || {
        startDate: null,
        endDate: null,
      },
      opens: "left",
      singleDatePicker: false,
      timePicker: true,
      timePicker24Hour: true,
      showWeekNumbers: false,
      showDropdowns: true,
      autoApply: false,
      linkedCalendars: false,
      ranges: {
        "Last 7 Days": [last7DaysStart, today],
        "This Month": [thisMonthStart, today],
        "Last Month": [lastMonthStart, lastMonthEnd],
        "This Quarter": [thisQuarterStart, today],
        "Last Quarter": [lastQuarterStart, lastQuarterEnd],
        "This Year": [thisYearStart, today],
      },
    };
  },
  watch: {
    value(newVal) {
      this.internalDateRange = newVal;
    },
  },
  methods: {
    updateValues(value) {
      this.internalDateRange = value;
      this.$emit("input", value); // v-model compatibility
    },
    formatDate(date) {
      return date ? moment(date).format("Do MMMM YYYY") : "";
    },
  },
};
</script>
<style scoped>
.compact-date-display {
  display: inline-block;
  padding: 0;
  margin: 0;
  border: none;
  font-size: 14px;
  line-height: 1.2;
  color: inherit;
  background: transparent;
}

/* Remove all spacing from the picker container */
::v-deep .daterangepicker {
  margin: 0;
  padding: 0;
}

::v-deep .daterangepicker .calendar-table {
  padding: 0;
  margin: 0;
}

::v-deep .daterangepicker::before,
::v-deep .daterangepicker::after {
  display: none;
}
</style>
